// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"styles_infoWrapper__2Qkdr","title":"styles_title__3MxIb","description":"styles_description__4ujrK","linksContainer":"styles_linksContainer__1IUdv"};